import { GetCombinedLicenseResponseEvent } from './events';
import { Context, Scope } from './types';

export const loadingTrue = (): Partial<Context> => {
  return {
    loading: true,
  };
};

export const loadingFalse = (): Partial<Context> => {
  return {
    loading: false,
  };
};

export const setData = (scope: Scope): Partial<Context> => {
  const { output } = scope.event as GetCombinedLicenseResponseEvent;
  return {
    data: output.data,
  };
};
